import TotalUsageStatsContainer from 'components/feature/statistics/total/TotalUsageStatsContainer';

const TotalUsageStatsPage = () => {
  return <TotalUsageStatsContainer />;
};
export default TotalUsageStatsPage;
